
import React, { useState, useEffect } from "react";


const WebsiteAnnouncement = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowPopup(true);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    if (!showPopup) return null;

    return (
        <div className="announcement-overlay">
            <div className="announcement-popup">

                <button
                    className="announcement-close"
                    onClick={() => setShowPopup(false)}
                    aria-label="Close announcement"
                >
                    &times;
                </button>

                <div className="announcement-icon">
                    🌐
                </div>

                <div className="announcement-content">

                    <span className="announcement-tag">
                        Important Announcement
                    </span>

                    <h2>Looking for Our Old Website?</h2>

                    <p>
                        The old website can still be accessed from
                    </p>

                    <a
                        href="http://booking.funforay.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="announcement-link"
                    >
                        booking.funforay.com ↗
                    </a>

                    <button
                        className="announcement-button"
                        onClick={() => setShowPopup(false)}
                    >
                        Continue to New Website
                    </button>

                </div>
            </div>
        </div>
    );
};

export default WebsiteAnnouncement;
